import { useEffect, useRef, useState } from "react";

import { Box } from "ui/box";
import { Spinner } from "ui/spinner";

import useOnScreen from "hooks/use-on-screen";

interface CommentLoaderProps {
  runOnLoading: () => Promise<boolean>;
}

export const CommentLoader = ({ runOnLoading }: CommentLoaderProps) => {
  const [allCommentsLoaded, setAllCommentsLoaded] = useState(false);

  const ref = useRef<HTMLDivElement>(null);
  const previousVisibilityRef = useRef(false);

  const isVisible = useOnScreen(ref as React.RefObject<HTMLElement>)

  useEffect(() => {
    const becameVisible = !previousVisibilityRef.current && isVisible;
    previousVisibilityRef.current = isVisible;

    if (!allCommentsLoaded && becameVisible) {
      runOnLoading().then((hasMore) => {
        setAllCommentsLoaded(!hasMore);
      });
    }
  }, [isVisible, allCommentsLoaded, runOnLoading]);

  return (
    <Box
      ref={ref}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
      {allCommentsLoaded ? (
        <Box component="p" sx={{ fontSize: "1.5rem", fontWeight: 700 }}>
          No more comments
        </Box>
      ) : (
        <Spinner size="md" />
      )}
    </Box>
  );
};
